/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticketpagetypesedit3Inputs */

const en_ticketpagetypesedit3 = /** @type {(inputs: Ticketpagetypesedit3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edit ticket types`)
};

const de_ticketpagetypesedit3 = /** @type {(inputs: Ticketpagetypesedit3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ticketarten bearbeiten`)
};

/**
* | output |
* | --- |
* | "Edit ticket types" |
*
* @param {Ticketpagetypesedit3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const ticketpagetypesedit3 = /** @type {((inputs?: Ticketpagetypesedit3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticketpagetypesedit3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticketpagetypesedit3(inputs)
	return de_ticketpagetypesedit3(inputs)
});
export { ticketpagetypesedit3 as "ticketPageTypesEdit" }